<template>
    <div class="modal-container show" v-if="showModal" :style="{zIndex: Ioptions.zIndex}">
        <div class="modal-overlay"></div>
        <div class="modal" :class="Ioptions.type" :style="forcedSize">
            <div class="header">
                <span v-html="Ioptions.title"></span>
                <i class="zmdi zmdi-close close" @click.stop="hide"></i>
            </div>
            <div class="content">
                <div class="container-fluid scroll">
                    <div class="row">
                        <div v-if="Ioptions.content" class="col-12 confirm-content" v-html="Ioptions.content"></div>
                        <component v-else :is="Ioptions.content_component" v-bind="Ioptions.content_component_props"></component>
                    </div>
                    <div class="row" v-if="Ioptions.doubleConfirm">
                        <div class="col-6">
                            <div class="col-12 simple-checkbox">
                                <input type="checkbox" id="doubleConfirm" v-model="doubleConfirmAccept"/>
                                <label for="doubleConfirm">{{ Ioptions.doubleConfirmMessage }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Toolbar class="not-fixed">
                <Btn class="primary" :class="[Ioptions.type,{disabled:Ioptions.doubleConfirm && !doubleConfirmAccept}]" @click.native.stop="accept">
                    {{ Ioptions.yesButtonText ? Ioptions.yesButtonText : $t('global.yes') }}
                </Btn>
                <Btn @click.native.stop="decline">
                    {{ Ioptions.noButtonText ? Ioptions.noButtonText : $t('global.no') }}
                </Btn>
            </Toolbar>

        </div>
    </div>
</template>

<script>
  import Toolbar from '@/components/ui/Toolbar';
  import Btn from '@/components/ui/Button';

  export default {
      name: 'Confirm',
      components: {
        Toolbar,
        Btn
      },
      props: {
        width:[Number],
        height:[Number],
        options: {
          type: [Object],
          default: function(){
            return {
              doubleConfirm: false,
              doubleConfirmMessage: '',
              title: '',
              content: '',
              callbackYes: null,
              callbackNo: null,
              zIndex: 300
            }
          }
        }
      },
      data () {
        return {
          Ioptions: {},
          showModal: false,
          doubleConfirmAccept: false
        }
      },
      computed: {
          forcedSize: function(){
            var style = ''
            if(this.width){
                style = style + 'width:' + this.width + ';'
            }
            if(this.height){
                style = style + 'height:' + this.height + ';'
            }
            return style
          }
      },
      methods: {
          show: function(options){
              this.Ioptions = options;
              if(!this.Ioptions.type){
                  this.Ioptions.type = 'danger'
              }
              if(!this.Ioptions.zIndex){
                  this.Ioptions.zIndex = 300
              }
              this.doubleConfirmAccept = false;
              window.Vfc.blurMode(true);
              this.showModal = true;
          },
          hide: function(){
              window.Vfc.blurMode(false);
              this.showModal = false;
          },
          accept: function(){
              if(this.Ioptions.callbackYes){
                  this.Ioptions.callbackYes();
              }
              this.hide();
          },
          decline: function(){
              if(this.Ioptions.callbackNo){
                  this.Ioptions.callbackNo();
              }
              this.hide();
          }
      },
      watch: {
          options: function(newValue){
              this.Ioptions = newValue;
          }
      }
  }
</script>

